enum GTMPageType {
  ERROR = 'error',
  CONTACTO = 'contacto',
  PRODUCTO = 'propuestas',
  RAMO = 'ramo',
  CONTRATACION = 'contratacion',
  BAJA = 'baja',
  AUTORIZACIONES = 'autorizaciones',
  INCIDENCIAS = 'incidencias',
  SUGERENCIAS = 'sugerencias',
  RECLAMACIONES = 'reclamaciones',
  FAQS_GENERAL = 'faqs_general',
  FAQS = 'faqs',
  SUCCESS = 'success',
  ENCUENTRANOS = 'encuentranos',
  DELEGACION = 'delegacion',
  TARIFICADOR = 'tarificador'
}

export default GTMPageType
